import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "axios";
import { AmbikaVenderApi } from "./camponents/config";
import { getDatabase } from "firebase/database"; // ✅ Realtime DB

const firebaseConfig = {
  apiKey: "AIzaSyD78x8QV88N2A7r_nOuz1TOCQr4B6pRnlo",
  authDomain: "ambika-3566b.firebaseapp.com",
  databaseURL:
    "https://ambika-3566b-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambika-3566b",
  storageBucket: "ambika-3566b.firebasestorage.app",
  messagingSenderId: "499535321922",
  appId: "1:499535321922:web:b44e2af0c26aeda48646db",
  measurementId: "G-9GEYFXRKPQ",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
export const db = getDatabase(app);

export const requestForToken = async (userId, authToken) => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BJknd9vYcmGC5F0zyYu_2TXtN4Zq6jCMdCApRxyB-F1CVTgT17ABI_QLCjtmSFI1Wywfmzqr3SjwR9fH5vtxjfk",
    });

    if (currentToken) {
      console.log("✅ Device Token:", currentToken);

      // 🔥 Send token to your backend
      await axios.post(
        `${AmbikaVenderApi}/updateDeviceToken`,
        {
          UserId: userId,
          DeviceToken: currentToken,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log("✅ Device token updated on backend");
    } else {
      console.log(
        "❌ Token not available. User might not have granted permission."
      );
    }
  } catch (error) {
    console.error("🚨 Error in getting/sending device token:", error);
  }
};

export { messaging, onMessage };
